// Module
var code = "<div class=\"search-result-row\"> <span ng-bind-html=\"match.label.user_uid | safeHighlight:query\"></span><br/> <small ng-bind-html=\"match.label.first_name | safeHighlight:query\"></small> <small ng-bind-html=\"match.label.last_name | safeHighlight:query\"></small> </div>";
// Exports
var _module_exports =code;;
var path = '/views/common/userTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;